export function TanyaUnitButton ({ slug }){
  const message = `Hi, saya ingin info unit dan berkonsultasi untuk produk dari BSD City! \n\nSaya dengan: \n\nTerima kasih!\n\nBSDWebsite, LSN: CAM-Performance-Konten-Blog-Organic-21082025-BSD-Website-${slug}`;

  const waUrl = `https://wa.me/628811382862?text=${encodeURIComponent(message)}`;

  return (
    <div className="mt-10 flex flex-wrap items-center justify-center gap-3 mb-4">
      <div className="w-auto text-center">
        <a
          href={waUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex cursor-pointer items-center justify-center gap-2 rounded bg-secondary px-14 py-3 text-sm font-medium text-white sm:text-base"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="white"
            viewBox="0 0 24 24"
          >
            <path d="M20.52 3.48A11.938 11.938 0 0 0 12.003 0C5.384 0 .001 5.384.001 12c0 2.116.553 4.173 1.601 5.999L0 24l6.196-1.597A11.96 11.96 0 0 0 12.002 24C18.62 24 24 18.617 24 12c0-3.193-1.247-6.198-3.48-8.52zM12.003 22.001a9.958 9.958 0 0 1-5.074-1.392l-.364-.214-3.679.947.982-3.582-.238-.368a9.956 9.956 0 0 1-1.484-5.393c0-5.514 4.486-10 10-10 2.675 0 5.188 1.045 7.07 2.93A9.935 9.935 0 0 1 22.002 12c0 5.514-4.486 10.001-10 10.001zm5.477-7.197c-.3-.15-1.775-.875-2.05-.975-.275-.1-.475-.15-.675.15-.2.3-.775.975-.95 1.175-.175.2-.35.225-.65.075-.3-.15-1.262-.463-2.404-1.477-.888-.789-1.488-1.763-1.662-2.063-.175-.3-.02-.462.13-.612.134-.133.3-.35.45-.525.15-.175.2-.3.3-.5.1-.2.05-.375-.025-.525-.075-.15-.675-1.625-.925-2.225-.242-.58-.487-.5-.675-.5-.175 0-.375-.025-.575-.025s-.525.075-.8.375c-.275.3-1.05 1.025-1.05 2.5 0 1.475 1.075 2.9 1.225 3.1.15.2 2.112 3.25 5.112 4.55.715.308 1.272.491 1.707.63.717.229 1.37.197 1.884.12.575-.087 1.775-.725 2.025-1.425.25-.7.25-1.3.175-1.425-.075-.125-.275-.2-.575-.35z" />
          </svg>
          Tanya Unit
        </a>
      </div>
    </div>
  );
}